import React, { Component } from 'react';
import { withRouter } from "react-router";
import AppContext from '../../AppContext'
import {
  Form,
  FormGroup,
  Label
} from 'reactstrap';

import Slider from '@mui/material/Slider';

import { withTranslation } from 'react-i18next';

import styles from '../../styles/toggleAudio.module.css';

import { isMobileSafari } from 'react-device-detect';


class VolumeSlider extends Component {

    constructor(props) {
        super(props)

        this.state = {
            audio: "audiofile.mp3",
            heatpumpAudio: true,
            initialVolumeSet: false,
            backgroundVolume: 100,
            currentDate: Date.now(),
            loop: true,
            gainNode: {},
            mediaSource: {},
            audioContext: {},
        }

    }

    static contextType = AppContext

    componentDidMount() {
      const { initialLoad, setInitialLoad } = this.context

      const { appVolume } = this.context;
      console.log(appVolume)

      if(!initialLoad) {
        this.changeBackgroundAudio(appVolume);
      }

      setInitialLoad(false)

    }

    changeBackgroundAudio(volume) {
        const { backgroundAudio, time, ambientAudio, backgroundAudioLevels } = this.context

        var convertedVolume = volume;
        var backgroundVolume = 0;

        if(time) {
            if(ambientAudio) {
                backgroundVolume = backgroundAudioLevels['outdoorNight'];
            }
            this.playBackgroundAudio(backgroundAudio[2],backgroundVolume*convertedVolume);

        } else {
            if(ambientAudio) {
                backgroundVolume = backgroundAudioLevels['outdoorDay'];
            }
            this.playBackgroundAudio(backgroundAudio[0],backgroundVolume*convertedVolume);
        }

    }

    playBackgroundAudio(source, volume) {
      const { setInitialLoad } = this.context

      var heatpump = document.getElementById("backgroundAudioContainer");

      if(!this.state.initialVolumeSet) {
        heatpump.src = require(`../../assets/audio/${ source }`)
      }

      if(!isMobileSafari) {
        if(!this.state.initialVolumeSet) {
            this.setState({initialVolumeSet: true})
            setInitialLoad(false)
            heatpump.play();
        }

        heatpump.volume = volume;
      } else {

        if(this.state.initialVolumeSet) {
            this.gainNode.disconnect();

            this.gainNode = this.audioContext.createGain();
            this.gainNode.gain.value = volume

            this.mediaSource.connect(this.gainNode);
            this.gainNode.connect(this.audioContext.destination);
        } else {
            heatpump.play();

            this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
            var myAudio = document.getElementById("backgroundAudioContainer");
            this.mediaSource = this.audioContext.createMediaElementSource(myAudio);

            this.gainNode = this.audioContext.createGain();
            this.gainNode.gain.value = volume

            this.mediaSource.connect(this.gainNode);
            this.gainNode.connect(this.audioContext.destination);

            this.setState({initialVolumeSet: true})
            setInitialLoad(false)

            console.log(this.audioContext)
        }
      }

    }

    async changeVolume(e,value) {

        this.setState({currentDate: Date.now()})

        const { setAppVolume } = this.context;

        await setAppVolume(value/100);

        this.changeBackgroundAudio(value/100);

    }


    render() {

    const { appVolume } = this.context;

    const { t } = this.props;

    var sliderValue = appVolume*100;

    return (

        <Form>
            <FormGroup>
                <Label for="exampleCustomRange"  style={{textAlign: 'left', fontSize: '14px', fontFamily: 'Bosch-Bold'}}>{t('welcome.sliderTitle')}</Label>

                <div style={{display: 'flex', flexDirection: 'row', width: '100%', marginTop: '15px'}}>
                    <div className={styles.volumeIcon}><img src={require(`../../assets/img/speaker_down.png`)} alt="Volume down" style={{width: '24px'}} /></div>
                    <div style={{width: '100%'}}>

                    <Slider
                        defaultValue={0}
                        size="small"
                        value={sliderValue}
                        onChangeCommitted={(e,value) => { this.changeVolume(e,value)}}
                        sx={{
                            width: '100%',
                            height: '3px',
                            color: '#008ECF',
                                '& .MuiSlider-thumb': {
                                borderRadius: '0px',
                                },


                            borderRadius: '0px',
                            paddingTop: '10px'
                        }}
                    />

                    </div>
                    <div className={styles.volumeIconRight}><img src={require(`../../assets/img/speaker_up.png`)} alt="Volume up" align="right" style={{width: '30px'}} /></div>
                </div>
            </FormGroup>

               <audio id="backgroundAudioContainer" style={{display: 'none'}} className={styles.hide}
                controls
                loop
                >
                    Your browser does not support the
                    <code>audio</code> element.
            </audio>

        </Form>

    );
  }
}

export default withRouter(withTranslation()(VolumeSlider));
